import React, { useEffect, useState } from 'react';
import { MemoryRouter } from 'react-router-dom';
import { Formik, Form } from 'formik';
import { CircularProgress } from '@mui/material';
import { StepsRouter, StyledCardSection } from '@fnol/library/src/components';
import { authClient } from '@fnol/library/src/api/auth';
import stepsComposer from '../../lib/stepsComposer';
import { prepareDataForSubmit } from '../../lib/helpers';
import { submitClaimData } from '../../rpc/actions';
import { IntroMessagesSlider } from '@fnol/library/src/components/IntroMessagesSlider';
import { getApplicationId, getIsSalesForce } from '@fnol/library/src/lib';
import introMessagesStepsComposer from '../../lib/introMessagesStepsComposer';

const MotorApp = () => {
    const [loggedIn, setLoggedIn] = useState<boolean>(false);
    useEffect(() => {
        authClient.login('motor', 227).then(() => setLoggedIn(true));
    }, []);

    return (
        <>
            {loggedIn ? (
                <Formik
                    enableReinitialize
                    initialValues={{
                        introMessagesOpen: true,
                        introMessagesSkipSteps: getIsSalesForce(getApplicationId()) ? [1, 2] : [],
                        activePolicies: [],
                        activePolicyId: '',
                        licenceNumber: '',
                        policyOrChassisNumber: '',
                        chassisNumber: '',
                        policyNumber: '',
                        policyOption: '',
                        dateOfOccurance: null,
                        hourOfOccurance: '',
                        minuteOfOccurance: '',
                        radios: '',
                        damages: [],
                        country: '197',
                        city: '',
                        cityInSerbia: {
                            id: '',
                            value: '',
                            text: '',
                            code: '',
                        },
                        street: '',
                        myCountry: '',
                        myCause: '',
                        cause: '',
                        uploadDocList: [],
                        documents: {
                            vehicleRegistration: '',
                            photos: '',
                            bankAccCard: '',
                            driversLicence: '',
                            euReport: '',
                            rest: '',
                        },
                        payment: '',
                        personalName: '',
                        personalLastName: '',
                        personalMobile: '+3816',
                        personalEmail: '',
                        serviceAdress: '',
                        driverName: '',
                        driverLastName: '',
                        driverMobile: '+3816',
                        smsContactMobile: '+3816',
                        vehicle: '',
                        vehicleTypeID: '',
                        vehicleLocation: '',
                        howDidDamageOccur: '',
                        declaration: '',
                        tempID: '',
                        tempPassContact: '',
                        oneTimePass: '',
                        submittedSuccessfully: false,
                        submitError: '',
                        skipSteps: [],
                    }}
                    onSubmit={(values, actions) => {
                        actions.setFieldValue('tempID', '');
                        submitClaimData(prepareDataForSubmit(values))
                            .then((res) => {
                                actions.setFieldValue('tempID', res.data);
                                actions.setFieldValue('submittedSuccessfully', true);
                                actions.setFieldValue('submitError', '');
                            })
                            .catch((error) => {
                                actions.setFieldValue('submittedSuccessfully', false);
                                actions.setFieldValue('submitError', error.response?.data);
                            })
                            .finally(() => {
                                actions.setSubmitting(false);
                            });
                    }}
                >
                    {({ values }) => (
                        <>
                            <MemoryRouter>
                                <IntroMessagesSlider
                                    open={values.introMessagesOpen}
                                    steps={introMessagesStepsComposer()}
                                    skipSteps={values.introMessagesSkipSteps}
                                />
                            </MemoryRouter>
                            <Form>
                                <MemoryRouter>
                                    <StyledCardSection>
                                        <StepsRouter steps={stepsComposer()} skipSteps={values.skipSteps} />
                                    </StyledCardSection>
                                </MemoryRouter>
                            </Form>
                        </>
                    )}
                </Formik>
            ) : (
                <CircularProgress />
            )}
        </>
    );
};

export default MotorApp;
